const bundle = {
  close: () => 'Fechar',
  error: () => 'Erro',
  warn: () => 'Aviso',
  info: () => 'Informações',
  confirmation: () => 'Confirmação',
  progressIndeterminate: () => 'A Decorrer',
  indexer_separatorLabel: (p: { FROM_SECTION: string; TO_SECTION: string }) =>
    'Entre ' + p['FROM_SECTION'] + ' e ' + p['TO_SECTION'] + '.',
  indexer_disabledLabel: (p: { SECTION: string }) =>
    p['SECTION'] + '. Nenhuma secção correspondente encontrada.',
  indexer_othersLabel: () => '#',
  indexer_keyboardInstructionText: () => 'Prima Enter para selecionar o valor.',
  indexer_touchInstructionText: () =>
    'Toque duas vezes e mantenha o toque para entrar no modo de gestos, em seguida, arraste para cima ou para baixo para ajustar o valor.',
  inputPassword_show: () => 'Mostrar Senha',
  inputPassword_hide: () => 'Ocultar Senha',
  inputPassword_hidden: () => 'Senha Oculta',
  formControl_clear: () => 'Limpar',
  formControl_loading: () => 'A Carregar',
  formControl_maxLengthExceeded: (p: { MAX_LENGTH: string }) =>
    'Comprimento máximo ' + p['MAX_LENGTH'] + ' excedido.',
  formControl_maxLengthRemaining: (p: { CHARACTER_COUNT: string }) =>
    p['CHARACTER_COUNT'] + ' caracteres em falta.',
  select_noMatchesFound: () => 'Não foram encontradas correspondências.',
  select_oneMatchFound: () => 'Foi encontrada uma correspondência',
  select_sizeMatchesFound: (p: { TOTAL_SIZE: string }) =>
    p['TOTAL_SIZE'] + ' correspondências encontradas',
  select_sizeOrMoreMatchesFound: (p: { TOTAL_SIZE: string }) =>
    p['TOTAL_SIZE'] + ' ou mais correspondências encontradas',
  selectMultiple_showSelectedValues: () => 'Mostrar só valores selecionados.',
  selectMultiple_valuesSelected: (p: { VALUE_COUNT: string }) =>
    p['VALUE_COUNT'] + ' valores selecionados.',
  selectMultiple_countPlus: (p: { COUNT: string }) => p['COUNT'] + '+',
  selector_selected: () => 'Caixa de seleção selecionada',
  selector_unselected: () => 'Caixa de seleção não selecionada',
  userAssistance_learnMore: () => 'Mais informações',
  userAssistance_required: () => 'Obrigatório',
  filePicker_singleFileUploadError: () => 'Carregue um ficheiro de cada vez',
  filePicker_singleTypeUploadError: (p: { fileType: string }) =>
    'Não é possível carregar ficheiros do tipo ' + p['fileType'],
  filePicker_multipleFileTypeUploadError: (p: { fileTypes: string }) =>
    'Não é possível carregar ficheiros do tipo: ' + p['fileTypes'],
  filePicker_unknownFileTypeUploadError: () => 'desconhecido',
  filePicker_dropzonePrimaryText: () => 'Arrastar e Largar',
  filePicker_dropzoneSecondaryText: () => 'Selecionar um ficheiro ou largar um aqui',
  filePicker_dropzoneSecondaryTextMultiple: () => 'Selecionar ou largar ficheiros aqui',
  filePicker_addFiles: () => 'Acrescentar Ficheiros',
  plural_separator: () => ', ',
  inputNumber_increase: () => 'Aumentar',
  inputNumber_decrease: () => 'Diminuir',
  inputNumber_converterParseError: () => 'Enter a number.',
  noData_message: () => 'Não existem itens para apresentação',
  message_navigationFromMessagesRegion: () =>
    'A entrar na região de mensagens. Prima F6 para navegar novamente para o elemento anteriormente focado.',
  message_navigationToMessagesRegion: () =>
    'A região das mensagens tem mensagens novas. Prima F6 para navegar para a mais recente região de mensagens.',
  messageToast_allMessagesClosed: () => 'Todas as mensagens de alerta foram fechadas.'
};
export default bundle;
